import { api } from 'trpc/react';

export const useApplyDelta = () => api.product.applyDelta.useMutation();
